export const getYearsRangeExecutions = (executions) => {
  const startYears = executions.map(e => e.executed_start_year);
  const endYears = executions.map(e => e.executed_end_year);
  return `${Math.min(...startYears)}-${Math.max(...endYears)}`;
};